import { render, staticRenderFns } from "./SelectorComponent.vue?vue&type=template&id=75d07b8a&scoped=true&"
import script from "./SelectorComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d07b8a",
  null
  
)

export default component.exports